var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5.75C4 5.33579 4.33579 5 4.75 5H9.00286C10.2301 5 11.3198 5.58958 12.0039 6.50106C12.688 5.58962 13.7777 5 15.005 5H19.25C19.6642 5 20 5.33579 20 5.75V16.25C20 16.6642 19.6642 17 19.25 17H14.7426C14.1459 17 13.5736 17.2371 13.1517 17.659L12.5303 18.2803C12.2374 18.5732 11.7626 18.5732 11.4697 18.2803L10.8484 17.659C10.4264 17.2371 9.8541 17 9.25736 17H4.75C4.33579 17 4 16.6642 4 16.25V5.75ZM12.755 8.75C12.755 7.50736 13.7624 6.5 15.005 6.5H18.5V15.5H14.7426C14.0326 15.5 13.3434 15.7014 12.7512 16.0724L12.755 8.75ZM11.2512 16.074L11.255 11.0007L11.2529 8.74786C11.2517 7.50605 10.2447 6.5 9.00286 6.5H5.5V15.5H9.25736C9.96836 15.5 10.6585 15.7019 11.2512 16.074Z",
    fill: "#B1D1FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.d6e93b2796b868b13b919b533d8b3f17.svg";
export { ForwardRef as ReactComponent };